<template>
    <div>
  <h1>dashboards111</h1>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped src="./../assets/style1.css"><style> 